import type { CustomNode } from '@src/components/custom-nodes/types';
import { v4 as uuid } from 'uuid';

interface GetPlaceholderProps {
  position: { x: number; y: number };
  height?: number | null;
  previousNodeHeight?: number | null;
  isPlaceholderVisible?: boolean;
  branchId?: string;
  parentBranchId?: string;
  parentNodeId?: string;
}

export const getPlaceholder = ({
    position,
    height,
    previousNodeHeight,
    isPlaceholderVisible=false,
    branchId='1',
    parentBranchId,
    parentNodeId
  }: GetPlaceholderProps) => {
  const placeholderNode = {
    id: `placeholder_${uuid()}`,
    type: 'PlaceholderNode',
    data: {
      label: '',
    },
    selectable: false,
    position: {
      x: position.x,
      y: position.y + ((previousNodeHeight ?? height) ?? 0),
    },
    height,
    style: {
      pointerEvents: 'none',
      visibility: isPlaceholderVisible ? 'visible' : 'hidden',
    },
    branchId,
    parentBranchId,
    parentNodeId,
  } as CustomNode;

  return placeholderNode;
}
